import * as React from 'react';
import { Config } from '../helper';

export default function FailedPlaceholder() {
  return (
    <div className='nv-learning-pathway-collection--failed'>
      <div className='container'>
        <div className='row'>
          <div className='col-lg-12'>
            {Config.I18n.LoadFailed}
          </div>
        </div>
      </div>
    </div>
  );
}
